import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";

import { Participant } from "./components/Participant";
import { Presenter } from "./components/Presenter";

// Loaded on demand, so participants' phones never download the admin area.
const Admin = lazy(() => import("./components/Admin"));

const path = window.location.pathname.replace(/\/+$/, "");

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		{path === "/admin" ? (
			<Suspense fallback={null}>
				<Admin />
			</Suspense>
		) : path === "/live" ? (
			<Presenter />
		) : (
			<Participant />
		)}
	</StrictMode>,
);
